import { useFlag } from '@calendly/feature-check-react'

import { rootApi } from 'root-api'

import { apiOwnerListLegacyUrl, apiOwnerListUrl, apiWorkflowNewUrl } from './url'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getNewWorkflowPermissions: build.query({
      query: ({ owner, workflowsExtractionEnabled }) => {
        if (workflowsExtractionEnabled) {
          return {
            url: '/api/apps/workflows/send_options',
            params: {
              owner_type: owner.type,
              owner_id: owner.id
            }
          }
        }

        return ({
          url: apiWorkflowNewUrl(owner),
        })
      },
      extraOptions: {
        handleErrors: false
      }
    }),
    getOwnersListLegacy: build.query({
      query: (params) => ({
        url: apiOwnerListLegacyUrl,
        params
      }),
      extraOptions: {
        handleErrors: false
      }
    }),
    getOwnersList: build.query({
      query: (params) => ({
        url: apiOwnerListUrl,
        params
      }),
      extraOptions: {
        handleErrors: false
      }
    })
  })
})

export const useGetOwnersListQuery = (params) => {
  const workflowsExtractionEnabled = useFlag('raven_workflows_extraction')

  return workflowsExtractionEnabled
    ? api.useGetOwnersListQuery(params)
    : api.useGetOwnersListLegacyQuery(params)
}

export const {
  useGetNewWorkflowPermissionsQuery
} = api
